import React from 'react';
import { ArrowRight, Flame, Clock, Beef } from 'lucide-react';
import { photos } from '../photos';

export default function Hero({ t }) {
  const h = t.hero;

  return (
    <section className="relative bg-paper pt-[72px]">
      <div className="max-w-[1440px] mx-auto grid lg:grid-cols-2">
        <div className="relative px-5 sm:px-8 lg:px-12 xl:px-16 py-12 lg:py-20 flex flex-col justify-center bg-track">
          <span className="font-display text-xs tracking-[0.32em] uppercase text-ember mb-5">
            01 — {h.badge}
          </span>

          <h1 className="font-display font-semibold uppercase leading-[0.88] tracking-tight text-ink">
            <span className="block text-6xl sm:text-7xl lg:text-8xl">{h.line1}</span>
            <span className="block text-6xl sm:text-7xl lg:text-8xl text-ember">{h.line2}</span>
            <span className="block text-6xl sm:text-7xl lg:text-8xl text-ink/20">{h.line3}</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-stone max-w-xl leading-relaxed">{h.sub}</p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="/s"
              className="inline-flex items-center gap-2 px-7 py-4 bg-ember text-ink font-bold uppercase tracking-[0.12em] text-sm hover:bg-ink hover:text-paper transition-colors duration-200"
            >
              {h.cta}
              <ArrowRight size={18} strokeWidth={2.5} />
            </a>
            <a
              href="#platform"
              className="inline-flex items-center gap-2 px-7 py-4 border border-ink text-ink font-bold uppercase tracking-[0.12em] text-sm hover:bg-ink hover:text-paper transition-colors duration-200"
            >
              {h.ctaSecondary}
            </a>
          </div>
        </div>

        <div className="relative min-h-[540px] lg:min-h-[720px]">
          <div className="absolute inset-0 hero-cut overflow-hidden bg-pine">
            <img
              src={photos.hero}
              alt={t.media.hero}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/75 via-ink/15 to-ink/10" />
          </div>

          <div className="absolute top-6 right-5 sm:right-8 bg-cream px-4 py-3 shadow-lift max-w-[220px]">
            <p className="text-[10px] uppercase tracking-[0.2em] text-stone font-bold">{h.floating[0].title}</p>
            <p className="font-display text-xl uppercase text-ink mt-1">{h.floating[0].value}</p>
          </div>

          <div className="absolute left-5 sm:left-8 bottom-6 right-5 sm:right-8 lg:right-auto lg:max-w-sm bg-cream/95 backdrop-blur-sm p-4 shadow-lift">
            <p className="text-[11px] text-stone leading-snug">{h.chat[0].text}</p>
            <p className="mt-2 text-[12px] text-ink leading-snug border-l-2 border-ember pl-3">{h.chat[1].text}</p>
            <div className="mt-4 pt-3 border-t border-line">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-ember">{h.recipeCard.tag}</p>
              <p className="font-display text-2xl uppercase leading-none mt-1">{h.recipeCard.title}</p>
              <div className="mt-3 flex flex-wrap gap-3 text-[11px] font-semibold text-stone">
                <span className="inline-flex items-center gap-1"><Flame size={12} className="text-ember" /> {h.recipeCard.kcal}</span>
                <span className="inline-flex items-center gap-1"><Beef size={12} className="text-ember" /> {h.recipeCard.protein}</span>
                <span className="inline-flex items-center gap-1"><Clock size={12} className="text-ember" /> {h.recipeCard.time}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-ink text-paper">
        <div className="max-w-[1440px] mx-auto grid grid-cols-3">
          {h.stats.map((s, i) => (
            <div key={s.label} className={`px-4 sm:px-8 py-6 sm:py-8 ${i > 0 ? 'border-l border-white/10' : ''}`}>
              <p className="font-display text-3xl sm:text-5xl uppercase leading-none">{s.value}</p>
              <p className="mt-2 text-[11px] sm:text-xs uppercase tracking-[0.14em] text-paper/70">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
